import { defaults, find, go } from 'fxjs/es';
import axios from 'axios';
import { makeApiUrl } from '../../../../../Util/S/Function/util.js';
import { makeMainThumbnailFromProduct } from '../../../F/fs.js';
import { getJustifyImageSize, resizeCanvas } from '../../../../../Maker/F/canvas_trim.js';
import { createCanvasElement } from '../../../../../Canvas/S/util.js';
import { drawProductFace } from '../../../../../Maker/F/draw_product_faces.js';
import { VectorEditorConstantS } from '../../../../../VectorEditor/S/Constant/module/VectorEditorConstantS.js';

function makeTrimedDrawFace({ width, height }, pf) {
  return go(
    createCanvasElement({ width, height }),
    (c) => drawProductFace(c, pf, undefined, false, true),
    (canvas) => {
      const { x, y, w, h } = getJustifyImageSize({ canvas });
      const ctx = canvas.getContext('2d');
      const imageData = ctx.getImageData(x, y, w, h);
      const _canvas = document.createElement('canvas');
      const _ctx = _canvas.getContext('2d');
      if (w > h) {
        _canvas.width = w;
        _canvas.height = w;
        _ctx.putImageData(imageData, 0, (w - h) / 2);
        return _canvas;
      } else {
        _canvas.width = h;
        _canvas.height = h;
        _ctx.putImageData(imageData, (h - w) / 2, 0);
        return _canvas;
      }
    },
  );
}

async function makeToDataUrlThumbnail(
  { base_product_id, product_faces2 },
  thumbnail,
  thumbnail_size,
  maker_type,
) {
  const pf = find((pf) => pf.bpf_id === thumbnail.bpf_id, product_faces2.value);
  if (!pf) return thumbnail;
  const ratio = 1;
  const { width, height } = { width: 860 * ratio, height: 860 * ratio };
  return go(
    [VectorEditorConstantS.ACRYLIC_FIGURE_EDITOR, VectorEditorConstantS.KEYRING_EDITOR].includes(maker_type)
      ? drawProductFace(createCanvasElement({ width, height }), pf, undefined, false, true)
      : makeTrimedDrawFace({ width: width * 1.5, height: height * 1.5 }, pf, base_product_id),
    (c) => {
      const url = thumbnail_size ? resizeCanvas(c, thumbnail_size).toDataURL() : c.toDataURL('image/png', 1);
      return defaults(
        {
          url,
        },
        thumbnail,
      );
    },
  );
}

const cache_composite_templates = new Map();
async function getCompositeTemplate(api_url, composite_template_id) {
  const cache_composite_template = cache_composite_templates.get(composite_template_id);
  if (cache_composite_template) return cache_composite_template;
  const {
    data: { composite_templates },
  } = await axios.get(makeApiUrl(api_url, { lang: T.lang }), {
    params: {
      composite_template_ids: [composite_template_id],
    },
  });
  cache_composite_templates.set(composite_template_id, composite_templates[0]);
  return cache_composite_templates.get(composite_template_id);
}

export async function setCompositeThumbnail({
  thumb,
  product: { product_faces2, base_product_size_id, base_product_id, base_product_color_id, thumbnails },
  thumbnail_size,
  api_url,
  maker_type,
}) {
  const thumb_composite_template_id = thumb?.composite_template_id;
  if (thumb_composite_template_id) {
    const _thumb = go(
      thumbnails.value,
      find((_thumb) => {
        return _thumb.composite_template_id == thumb_composite_template_id;
      }),
    );
    const composite_template = await getCompositeTemplate(api_url, _thumb.composite_template_id);
    const { url, design_ready_url } = await makeMainThumbnailFromProduct({
      product: { product_faces2, base_product_size_id, base_product_id, base_product_color_id },
      composite_template,
      thumbnail_size,
      maker_type,
    });
    return { url, design_ready_url };
  } else {
    const _thumb = await makeToDataUrlThumbnail(
      { product_faces2, base_product_id },
      thumb,
      thumbnail_size,
      maker_type,
    );
    return { url: _thumb.url };
  }
}
